import { post } from "aws-amplify/api";

export default async function translateText(text, targetLanguage = "ru") {
  try {
    // Call the Lambda function via API Gateway
    const restOperation = post({
      apiName: "learnserbianappRESTapi",
      path: "/translateText",
      options: {
        body: {
          text: text,
          targetLanguage: targetLanguage,
        },
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();

    console.log("response: ", response);

    // Check if the response contains valid translation data
    if (response && response.translatedText) {
      console.log(`Translated text: ${response.translatedText}`); // Log the translated text
      return response.translatedText; // Return the translated text
    } else {
      // Throw an error if the response format is invalid
      throw new Error("Translation response is invalid");
    }
  } catch (error) {
    // Handle errors during the Lambda invocation
    console.error("Lambda Translate API Error:", error);
    return ""; // Return an empty string or a fallback translation in case of an error
  }
}
